import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import FavouriteIcon from '../../../../Favourite/FavouriteIcon';
import ProductPhoto from '../../../../Table/components/ProductPhoto';
import FairWeekInput from '../FairWeekInput/FairWeekInput';
import blackStar from '../../../../../assets/images/black-star-icon.png';

const ORDERABLE_TYPES = ['X', 'G', 'NP', 'B'];

const getFirstGadgetWeekDate = (productItem, weeks) => {
    if (!productItem || !productItem.gadget) {
        return null;
    }

    const promoWeek = weeks.find((week) => {
        const weekData = (productItem.fair_product_promotions || []).find(
            (item) => item.week_date === week.week_date
        );
        return (
            weekData &&
            ORDERABLE_TYPES.includes(weekData.promo_type) &&
            weekData.promo_type !== 'X'
        );
    });

    return promoWeek
        ? promoWeek.week_date
        : weeks[0]
        ? weeks[0].week_date
        : null;
};

const FairProductCard = ({
    productItem,
    index,
    weeks,
    showProductPhoto,
    addProduct,
    setFairProducts,
    loadingState,
    pageSize,
    onWeekFocus,
    onWeekBlur,
}) => {
    if (!productItem || !productItem.product) {
        return null;
    }

    const { product } = productItem;
    const gadgetWeekDate = getFirstGadgetWeekDate(productItem, weeks);

    return (
        <div
            className={`fair-product-card ${
                showProductPhoto ? 'fair-product-card--with-photo' : ''
            }`}
        >
            <div className="fair-product-card__main">
                {showProductPhoto && (
                    <div className="fair-product-card__photo">
                        <ProductPhoto product={product} />
                    </div>
                )}
                <div className="fair-product-card__content">
                    <div className="fair-product-card__header">
                        <FavouriteIcon
                            type="product"
                            id={product.id}
                            onClick={() => {}}
                            isFavourite={product.isFavourite}
                        />
                        <div className="fair-product-card__title">
                            <span className="fair-product-card__article">
                                {product.article_nr}
                            </span>
                            <span className="fair-product-card__separator">
                                {' '}
                                —{' '}
                            </span>
                            <span className="fair-product-card__name">
                                {product.name}
                            </span>
                            {product.supplier ? (
                                <span className="fair-product-card__supplier">
                                    {' '}
                                    / {product.supplier}
                                </span>
                            ) : null}
                        </div>
                        {productItem.isClientProduct ? (
                            <div className="fair-product-card__assortment">
                                <img src={blackStar} alt="" />
                                <FormattedMessage id="fair.in_my_assortment" />
                            </div>
                        ) : null}
                    </div>
                    <div
                        className="fair-product-card__weeks"
                        style={{
                            gridTemplateColumns: `repeat(${Math.max(
                                weeks.length,
                                1
                            )}, minmax(40px, 1fr))`,
                        }}
                    >
                        {weeks.map((week) => (
                            <FairWeekInput
                                key={week.week_date}
                                productItem={productItem}
                                index={index}
                                week={week}
                                weeks={weeks}
                                addProduct={addProduct}
                                setFairProducts={setFairProducts}
                                loadingState={loadingState}
                                pageSize={pageSize}
                                showProductGadget={
                                    gadgetWeekDate === week.week_date
                                }
                                onWeekFocus={onWeekFocus}
                                onWeekBlur={onWeekBlur}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <div className="fair-product-card__discount">
                <span className="fair-product-card__discount-label">
                    <FormattedMessage id="fair.discount_summary_box.title" />
                </span>
                <div className="fair-product-card__discount-value">
                    &euro;&nbsp;{productItem.total_discount || 0}
                </div>
            </div>
        </div>
    );
};

FairProductCard.propTypes = {
    productItem: PropTypes.object,
    index: PropTypes.number,
    weeks: PropTypes.array,
    showProductPhoto: PropTypes.bool,
    addProduct: PropTypes.func,
    setFairProducts: PropTypes.func,
    loadingState: PropTypes.object,
    pageSize: PropTypes.number,
    onWeekFocus: PropTypes.func,
    onWeekBlur: PropTypes.func,
};

export default FairProductCard;
